export default __webpack_public_path__ + "static/media/bkg--home-2.a5d044a7.jpg";